<template>
    <div class="alert alert-danger">
        No sidebar defined for this user type
    </div>
</template>

<script>
export default {
  name: 'GenericAppSidebar',
  apollo: {},
  data() {
    return {
      loading: 0,
    };
  },
  computed: {},
  methods: {
    isActiveItem(url) {
      return this.$route.path.startsWith(url);
    },
  },
};
</script>
